"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a, carmiProps) {
    var compData = _a.compData, compProps = _a.compProps;
    return __assign(__assign({}, carmiProps), { noReviewsMode: compProps.noReviewsMode, rating: compData.rating, noReviewsPlaceholder: compData.noReviewsPlaceholder, numRatings: compData.numRatings, reviewsCountLabel: compData.reviewsCountLabel, showReviewsCount: compProps.showReviewsCount, showRating: compProps.showRating });
});
var getMargins = function (compProps, positionAfter, rtl) {
    var displayLabelsSpacing = Math.max(compProps.shapeSpacing, 15) + "px";
    var cssVars = {};
    if (compProps.showRating) {
        var ratingMargin = "--ratingMargin" + ((positionAfter && !rtl) || (!positionAfter && rtl) ? 'Left' : 'Right');
        cssVars[ratingMargin] = displayLabelsSpacing;
    }
    if (compProps.showReviewsCount) {
        cssVars["--numReviewsMargin" + (rtl ? 'Right' : 'Left')] = positionAfter
            ? '15px'
            : displayLabelsSpacing;
    }
    return cssVars;
};
exports.css = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a, carmiCss) {
    var _b;
    var compData = _a.compData, compProps = _a.compProps;
    var shapeSize = compProps.shapeSize, shapeSpacing = compProps.shapeSpacing, direction = compProps.direction, alignment = compProps.alignment, ratingPosition = compProps.ratingPosition, showRating = compProps.showRating, showReviewsCount = compProps.showReviewsCount;
    var positionAfter = ratingPosition === 'after';
    var rtl = direction === 'rtl';
    var justifyContent = {
        center: 'center',
        left: rtl ? 'flex-end' : 'flex-start',
        right: rtl ? 'flex-start' : 'flex-end',
    };
    var cssVars = __assign(__assign({}, carmiCss), (_b = { '--iconsMinWidth': 4 * shapeSpacing + 5 * shapeSize + "px", '--iconsOrder': positionAfter ? 0 : 2, '--displayJustifyContent': justifyContent[alignment], '--iconSize': shapeSize + "px" }, _b["--iconPadding" + (rtl ? 'Left' : 'Right')] = shapeSpacing + "px", _b['--direction'] = direction, _b['--halfIconWidth'] = shapeSize / 2 + "px", _b));
    if (rtl) {
        cssVars['--halfIconLeft'] = shapeSize / 2 + "px";
    }
    if (compData.rating && (showRating || showReviewsCount)) {
        return __assign(__assign({}, cssVars), getMargins(compProps, positionAfter, rtl));
    }
    return cssVars;
});
//# sourceMappingURL=RatingsDisplay.js.map